import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { Card,Pagination,Input } from 'antd';
import useFetchCauses from '../../hooks/fetchCauses';
import getCauseByOrg from '../../hooks/getCauseByOrg';
import getEventsByOrg from '../../hooks/getEventsByOrg';
// import getPrayersByOrg from '../../hooks/getPrayersByOrg';
import useFetchCities from '../../hooks/fetchCities';
import { app } from '../../config';
import NewSideBar from '../../components/Sidebar/NewSideBar';
import { EditTwoTone } from '@ant-design/icons';


const Country = () => {
  const { t } = useTranslation(['common']);
  const { Search } = Input;
  const [countries,setCountries] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [commonData, setCommonData] = useState([]);
  const [renderList,setRenderList] = useState([]);
  const [current, setCurrent] = useState(1);
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  const c=useFetchCities()
  // console.log(c)
  // const cities=c.response?c.response.data:[];
  // const citiesCount=c.response?c.response.data.length:0
  useEffect(() => {
    const fetchEvents=async()=>{
      const limit=6;
      const offset=0;
      const c=await axios.get(`${app.URL}/country/view`);
      console.log(c);
      console.log(c.data.data)
      c.data?setCountries(c.data.data):[];
      c.data?setPagesCount(c.data.data.length):[];
      c.data?setCommonData(c.data.data):[];
      c.data?setRenderList(c.data.data.slice(0,6)):[];
      }
      fetchEvents();

  }, []);
  // const p=getPrayersByOrg(user.organizationId);
  // console.log(p);
  // let prayers=p.response?p.response.data:[];
  // console.log(prayers);
  const addCountry=(e)=>{
    console.log(e);
    navigate('/country/add',{replace:true});
}
const editCountry = (e) => {
  console.log(e);
  localStorage.setItem('countryId', JSON.stringify(e.countryId));
  navigate('/country/edit', { replace: true });
};
const onSearch = async (value) => {
  console.log(value);
  try {
    const result = await axios.get(`${app.URL}/country/search/${value}`);
    console.log(result.data.data);
    result.data ? setCommonData(result.data.data) : [];
    result.data ? setRenderList(result.data.data.slice(0, 6)) : [];
    result.data ? setPagesCount(result.data.data.length) : 0;

  } catch (e) {
    console.log('Error');
    console.log(e);
    if (e.message) setErr(e.response.data.message);
    setTableShow(false);
  }



}
const handleSearchChange = (e) => {
  console.log(e.target.value);
  if (!e.target.value) {
    setRenderList(countries.slice(0,6));
    setCommonData(countries);
    setCurrent(1)
    setPagesCount(countries.length);
  }
};
const onChange = async (page, pageSize) => {
  console.log(page, pageSize);
  setCurrent(page);
  if (!page) page = 1;
  let limit = pageSize;
  let reqObj = {
    limit,
    offset: limit * (page - 1),
  };
  console.log(reqObj);
  setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
};

  return (
  
    // <div className='row w-100'>
    // <OrgNav />
    // <div className='col-lg-3 col-md-4 col-sm-12'>
    //   <NewSideBar />
    // </div>

    <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
      <div className='row text-center mt-4'>
        <div className='col-lg-11 col-md-12 col-sm-12'>
          <Search
            placeholder='input search text'
            onSearch={onSearch}
            onChange={handleSearchChange}
            style={{
              width: 300,
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-8 col-md-8 col-sm-12 '>
          <div class='mt-4 fs-3 fw-bold'> {t('Countries')} </div>
        </div>
        <div className='col-lg-3 offset-lg-1 col-md-4 col-sm-12 p-7'>
        <button class="btn btn-primary button" onClick={addCountry}>Add Country</button>
        </div>
      </div>
      <div className='row'>
      {renderList?renderList.map((country)=>{
            
            return(

              <div key={country.countryId} class='col-lg-4 col-md-6 col-sm-12 text-black mt-3 mb-3 '>
              <Card
                title={<h1 class="fw-bold">{country.name}</h1>}
                bordered={false}
                style={{
                  width: 250, 
                  maxHeight:300,
                  wordWrap:'break-word',
                  fontSize:14,
                  
                  // inlineSize:"250px"
                }}
                class="tbl mt-3"
              >
                 {/* <p><b class='fw-bold'>State:</b> {state.state} </p> */}
                 <p><b class='fw-bold'>Currency:</b>{country.currencySymbol}</p>
                 <p><b class='fw-bold'>Status: </b>{country.status==="Inactive"?<span style={{color:"red"}}>{country.status}</span>:<span>{country.status}</span>}</p>
                 <EditTwoTone
                    className='mt-2'
                    displayName='edit'
                    twoToneColor='blue'
                    style={{ fontSize: '25px' }}
                    onClick={() => {
                      editCountry(cause);
                    }}
                  />
              </Card>
              </div>
            )
               
          }):""}
       
      </div>
      <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} pageSize={6} total={pagesCount} />  
    </div>
  // </div>
  );
};

export default Country;
